import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import { useQuery } from '@apollo/client'

import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'

import { LoggedInUserContext } from './contexts'

import GET_ME from '../graphql/get-me'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
}

let previousPath = ''

const Layout = ({ children, location: { pathname, search } }) => {
  // Get user
  const { loading, error, data } = useQuery(GET_ME)
  if (loading) return null

  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    previousPath = currentPath
  }, 300)

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]
  const isUserAuthorized = localStorage.getItem('accessToken')
  const isUserLoading = loading
  const isAuthLayout = getLayout() === 'auth'

  const BootstrappedLayout = () => {
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (isUserLoading && !isUserAuthorized && !isAuthLayout && !data) {
      return null
    }

    // redirect to login page if current is not login page and user not authorized
    if (!isAuthLayout && !isUserAuthorized) {
      return <Redirect to="/auth/login" />
    }

    let me
    if (data) {
      // eslint-disable-next-line prefer-destructuring
      me = data.me
    }
    if (error) {
      localStorage.removeItem('accessToken')
    }

    // in other case render previously set layout
    return (
      <LoggedInUserContext.Provider value={me}>
        <Container>{children}</Container>
      </LoggedInUserContext.Provider>
    )
  }

  return (
    <Fragment>
      <Helmet titleTemplate="Jiwe Admin" title="Jiwe Admin" />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect()(Layout))
